/*
**@author:1554382338@qq.com
**@date:21017/11/21
*/
/*首页友情链接添加鼠标进去切换效果*/
+(function(){
  $('.friend-links .nav-tabs li').on('mouseenter', function(event) {
    $(this).find('a').click();
  });
})();

+(function () {
  /**
  *抖动未优化
  **/
 if(document.body.clientWidth>1200||document.body.clientWidth==1200){
	var items = $(".hot-report #items");
  var defaultdelay = 17;
  var maxdelay = 8; 
	var maxheight = $(".hot-report .items").height();
  var setTime;
  /*
  * @description: 执行滚动
  * @param: {jquery对象}elem
  * @param: {string} drection (目前仅支持向上滚动的"up",向下滚动的"down")
  * @returns:undefined
  */
	function go(elem,drection) {
		var top =elem.position().top;
      if (top<=0&&-top<=maxheight) 
      {
        drection == "up" ? top-- : top++;
       elem.css('top', top);
      }
      else{
        if (top>0) {
           stop(setTime) 
        }
        elem.css('top', 0);  
      }
	} 
  /*
  *@description:停止执行滚动函数go()
  *@param:{setInterval返回的ID} setTime
  *@return:undefind
  */
  function stop(setTime){
    clearInterval(setTime);
  }

  /*
  *@description:重新设置定时器执行滚动go()
  *@param:{string} drection(目前仅支持向上滚动的"up",向下滚动的"down")
  *@param:{number} speed (go()执行周期（以毫秒计，speed值越大滚动速度越小)
  */
  function restart(drection,speed) {
    setTime = setInterval(function(){
      go(items,drection);
    },speed);
  }

  /*
  *克隆一份追加到后面,方便实现无缝滚动
  *@return undefind
  */
  function clone(){
    $(".hot-report .items").clone().prependTo(".hot-report #items");
  }
  
  /*
  *@description:鼠标移入滚动区域停止滚动，鼠标移除滚动区继续滚动
  */
  function mouseEventStop(){
    $(".hot-report .itemswap").on({
      "mouseenter":function(argument) {
        stop(setTime);
      },
      "mouseleave":function(argument) {
        restart("up",defaultdelay);
      }
    });
  }
  
  /*
  *@description:鼠标移入加速区加速，移除加速区恢复默认速度，上下加速区加速方向不同
  */
  function mouseEventUpSpeed(){
    $(".hot-report .ctrl-pre").on({
      "mouseenter":function(argument) {
          stop(setTime);
          restart("up",maxdelay);
      },
      "mouseleave":function(argument) {
          stop(setTime);
          restart("up",defaultdelay);
      }
    });
    $(".hot-report .ctrl-next").on({
      "mouseenter":function(argument) {
        stop(setTime);
        restart("down",maxdelay);
      },
      "mouseleave":function(argument) {
        stop(setTime);
        restart("up",defaultdelay);
      }
    });
   }

  /*
  *@description:初始化函数
  */
  function init(){
    clone(); 
     setTime = setInterval(function(){
      go(items,"up");
    },defaultdelay);
    mouseEventStop();
    mouseEventUpSpeed();
  }

  init();
 }
})();



// WEBPACK FOOTER //
// ./src/pages/base/base.js